export default "__VITE_ASSET__tyfQCOS8__"